import type { MockPersona } from './types'

/** New signup, no donations, no Gift Aid authorisation, no statements yet. */
export const sheilaMartini: MockPersona = {
  id: 'sheila-martini',
  label: 'Sheila Martini',
  description: 'Just signed up; no donations and no Gift Aid authorisation yet',
  defaultPlan: 'free',
  me: {
    landingPage: 100,
    emailAddress: 'sheila.martini@example.com',
    details: {
      firstname: 'Sheila',
      lastname: 'Martini',
      addressLine1: '3 Harbour View',
      addressLine2: 'Flat 2',
      city: 'Bristol',
      postcode: 'BS1 4DJ',
      county: '',
      country: 'United Kingdom',
    },
    accounts: [
      {
        type: 'emailAddress',
        id: 'sheila.martini@example.com',
        created: '2026-06-01T09:15:00.000Z',
        updated: '2026-06-01T09:15:00.000Z',
      },
    ],
  },
  donations: { financialYears: [] },
  statements: { statements: [] },
  authorisation: null,
}
